export class BenefitCardConstants {
  public static readonly ONGOING_STATUS = "Ongoing";
  public static readonly CANCELLATION_PENDING_STATUS = "CancellationPending";
  public static readonly ENROLLMENT_PENDING_STATUS = "EnrollmentPending";
  public static readonly FOR_APPROVAL_STATUS = "ForApproval";
  public static readonly INVALID = "Invalid";
  public static readonly MYEVENT = "MyEvent"
}
